import {HoistService, InitContext, LoadSpec, XH} from '@xh/hoist/core';
import {observableRef, runInAction} from '@xh/hoist/mobx';
import {ExchangeInfo} from '../data/DataTypes';
import {getDefaultOptions} from '../../core/ServiceUtils';

export class ExchangeService extends HoistService {
    @observableRef accessor exchangeInfo: ExchangeInfo;
    private timer;
    private selfTicks = 0;

    constructor() {
        super();

        this.addReaction({
            track: () => XH.appIsRunning,
            run: isRunning => {
                if (isRunning) this.timer = setTimeout(() => this.refresh(), 1000);
                else {
                    if (this.timer) console.warn('suspending exchange svc updates');
                    clearTimeout(this.timer);
                }
            },
            fireImmediately: true
        });
    }

    override async initAsync(ctx: InitContext): Promise<void> {
        console.log('initializing ExchangeService');
        await this.loadAsync();
    }

    override async doLoadAsync(loadSpec: LoadSpec): Promise<void> {
        const info: ExchangeInfo = await XH.fetchService
            .getJson({
                url: `${XH.getConf('svcApiUrl')}/exchange/info`,
                ...getDefaultOptions()
            })
            .catchDefault({alertType: 'toast'});

        if (info) runInAction(() => (this.exchangeInfo = info));

        this.selfTicks = 0;
    }

    private async refresh() {
        runInAction(
            () =>
                (this.exchangeInfo = {
                    ...this.exchangeInfo,
                    nextEventSec: this.exchangeInfo.nextEventSec - 1
                })
        );

        if (!XH.appIsRunning) {
            return;
        }

        if (this.selfTicks++ >= 30) await this.loadAsync();

        setTimeout(() => this.refresh(), 1000);
    }
}
